(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global['vue-isoffline'] = factory());
}(this, (function () { 'use strict';

var isofflinePlugin = {
  install: function install (Vue, options) {
    if ( options === void 0 ) options = {};

    var vm = new Vue({
      data: {
        isoffline: !window.navigator.onLine
      }
    });
    window.addEventListener('online', function handleOnLine (e) {
      vm.$data.isoffline = false;
    });
    window.addEventListener('offline', function handleOffLine (e) {
      vm.$data.isoffline = true;
    });
    Vue.mixin({
      computed: {
        isOffLine: function isOffLine () {
          return vm.$data.isoffline
        }
      }
    });
  }
};

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(isofflinePlugin);
}

return isofflinePlugin;

})));
